import type { PropsWithChildren } from 'react'
import { useIntl } from '@/intl'
import { space, tok } from '@sunwebgroup/ui-components'
import { focusOutline, Icon, Popover, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

const InfoButton = styled.button`
  color: ${tok('semantics_content_secondary_color')};
  width: fit-content;

  ${focusOutline()}
`

const Heading = styled(Typography)`
  margin-bottom: ${space('primitives_space_16')};
`

const InfoButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${space('primitives_space_4')};
`

export function ProductAdsComponent({
  headerTitle,
  infoContent,
  infoLabel,
  className,
  children,
}: PropsWithChildren<{
  infoLabel?: string | null
  infoContent?: string | null
  headerTitle?: string | null
  className?: string
}>) {
  const intl = useIntl()
  return (
    <div className={className}>
      <Popover.Root>
        {infoLabel && infoContent && (
          <Popover.Trigger>
            <InfoButton>
              <InfoButtonContent>
                <Typography $variant="body-s-regular-tight">{infoLabel}</Typography>
                <Icon glyph="InformationInCircle" size={16} />
              </InfoButtonContent>
            </InfoButton>
          </Popover.Trigger>
        )}
        {headerTitle && (
          <Heading $variant="display-h-regular" as="h2">
            {headerTitle}
          </Heading>
        )}
        {children}
        <Popover.Content title={infoLabel ?? ''} position="top-right" showTitleOnDesktop={Boolean(infoLabel)} closeText={intl.formatMessage({ id: 'close' })}>
          <Typography>{infoContent}</Typography>
        </Popover.Content>
      </Popover.Root>
    </div>
  )
}
